// extracted by mini-css-extract-plugin
export var wordContainer = "_nd-0";